import LearnMore from 'js/pages/learn-more/index.js'

const meta = {
  layoutInfo: true
}

export default [
  {
    path: '/learn-more',
    name: 'learn-more',
    component: LearnMore,
    meta
  }
]
